import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/services/session-service';

@Component({
  selector: 'pla-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  styleUrls: ['./forgot-password-page.component.css'],
})
export class ForgotPasswordPageComponent {
  // Always show the same confirmation message regardless of whether the
  // email matches an account, so the UI does not leak account existence.
  public static readonly CONFIRMATION_MESSAGE =
    "If an account exists for that email, we've sent a password reset link. Please check your inbox (and your spam folder).";

  public emailControl = new FormControl('', [Validators.required, Validators.email]);
  public loading = false;
  public submitted = false;

  constructor(
    private sessionService: SessionService,
    private router: Router,
  ) {}

  public submit(): void {
    if (this.emailControl.invalid) {
      this.emailControl.markAsTouched();
      return;
    }
    const email = (this.emailControl.value ?? '').trim();
    this.loading = true;
    this.sessionService.requestPasswordReset(email).subscribe(
      // Identical UI treatment on success and error — never branch on the
      // response in a way that would tell a probing client whether the
      // account exists. Errors are swallowed deliberately.
      () => this.flipToConfirmation(),
      () => this.flipToConfirmation(),
    );
  }

  private flipToConfirmation(): void {
    this.loading = false;
    this.submitted = true;
  }

  public get confirmationMessage(): string {
    return ForgotPasswordPageComponent.CONFIRMATION_MESSAGE;
  }

  public backToSignIn(): void {
    this.router.navigate(['/login']);
  }
}
